<template>
  <div>
    <OnboardingIndex
      :title="title"
      :submit_button_text="submitButtonText"
      :url_forgot_password="url_forgot_password"
      :verification_running="verification_running"
      :custom_submit_button="true"
      @custom-submit="login_function"
    >
      <template v-slot:form-content>
        <div class="mx-auto w-100">
          <div class="mb-4">
            <label for="email" class="text-xs mb-2">Email Address</label>
            <input
              type="email"
              class="form-control form-control-sm text-xs bg-light border-0 py-2"
              v-model="username"
              id="email"
              placeholder="Enter Your Username"
              required
            />
          </div>

          <div class="mb-4">
            <div>
              <label for="password" class="text-xs mb-0">Password</label>
              <div class="position-relative">
                <input
                  :type="show_password ? 'text' : 'password'"
                  class="form-control form-control-sm text-xs bg-light border-0 py-2 pe-5"
                  v-model="password"
                  id="password"
                  placeholder="Enter Your Password"
                  required
                />
                <i
                  class="position-absolute end-0 top-50 translate-middle-y me-3 text-secondary cursor-pointer z-2"
                  role="button"
                  tabindex="0"
                  @click="toggle_password_visibility"
                  @keydown.enter.prevent="toggle_password_visibility"
                  @keydown.space.prevent="toggle_password_visibility"
                  :aria-label="show_password ? 'Hide password' : 'Show password'"
                  :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
                ></i>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <router-link
              to="/forgot_password"
              class="fw-semibold text-decoration-none small text-xs"
            >
              Forgot Password?
            </router-link>
          </div>
        </div>
      </template>

      <template v-slot:custom-button>
        <div class="d-grid pt-1">
          <button
            type="submit"
            class="btn btn-primary-dark shadow w-100"
            :disabled="verification_running"
          >
            {{ submitButtonText }}
          </button>
          <div class="mt-3 text-center">
            <div class="d-flex align-items-center gap-2">
              <div class="flex-grow-1 border-top border-dark"></div>
              <router-link
                to="/organization/signup"
                class="fw-semibold text-decoration-none small text-xs flex-shrink-0"
              >
                Or Create an organization account
              </router-link>
              <div class="flex-grow-1 border-top border-dark"></div>
            </div>
            <div class="text-dark text-xs mt-2">
              Existing Organization? Sign in here with your credentials.
            </div>
          </div>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>
